import Expandable from "../../generic-building-blocks/Expandable";
import CustomSubscribersTabTypeHeader from "./CustomSubscribersTabTypeHeader";
import SubscriberNotificationFilters from "./SubscriberNotificationFilters";
import SubscriberSignalFormat from "./SubscriberSignalFormat";
import { NotificationType, NotificationFilterType } from "@prisma/client";
import _ from "lodash";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";

export enum CustomSubscriberTabType {
  FORMATTING = "formatting",
  NOTIFICATIONS = "notifications",
}

interface Props {
  notificationPrefix: string;
  notificationType: NotificationType;
  includeTitle?: boolean;
  useMarkdown?: boolean;
  supportedTypes: NotificationFilterType[];
}

export default function CustomNotificationsAndSignals({
  notificationPrefix,
  notificationType,
  includeTitle = true,
  useMarkdown = true,
  supportedTypes,
}: Props): JSX.Element {
  const typeText = _.capitalize(notificationType);
  const { control } = useFormContext();
  const [subscriberTabType, setSubscriberTabType] = useState(CustomSubscriberTabType.FORMATTING);

  return (
    <Expandable
      title={<span className="font-semibold text-sm">Customize Formatting and Notifications</span>}
      tooltipText={`Overwrite the signal title and body only for ${typeText} notifications, and configure what notifications your subscriber should receive.`}
    >
      <CustomSubscribersTabTypeHeader tabType={subscriberTabType} setTabType={setSubscriberTabType} />
      {subscriberTabType === CustomSubscriberTabType.FORMATTING ? (
        <SubscriberSignalFormat
          control={control}
          notificationPrefix={notificationPrefix}
          notificationType={notificationType}
          includeTitle={includeTitle}
          useMarkdown={useMarkdown}
        />
      ) : (
        <div className="border border-1 p-5">
          <label className="block text-sm font-medium leading-5 text-gray-700 mb-1">Notification Preferences</label>
          <SubscriberNotificationFilters
            name={`${notificationPrefix}.notificationFilters`}
            supportedTypes={supportedTypes}
            notificationType={notificationType}
          />
        </div>
      )}
    </Expandable>
  );
}
